import fire from '@store/firebase';
import { Ihashtag } from '@typings/common/hashtag.interface';
const firestore = fire.firestore();

export async function getHashtagIdValueList(
  collectionPath,
  hashtagIdList,
): Promise<Ihashtag[] | null | any> {
  const hashtagRef = firestore.collection(`${collectionPath}Hashtag`);

  if (!hashtagIdList) return null;

  const valueMap = await Promise.all(
    hashtagIdList.map(async (id: string) => {
      const hashData = await hashtagRef
        .doc(id)
        .get()
        .then((res) => res.data());
      if (!hashData) return {};
      return { id, value: hashData.value || '' };
    }),
  );

  return valueMap;
}

export async function getHashtagIdByValue({
  value,
  collectionPath,
}): Promise<string | null> {
  const hashtagRef = firestore.collection(`${collectionPath}Hashtag`);

  if (!value) return null;

  const hashIds = await hashtagRef
    .where('value', '==', value)
    .get()
    .then((res) => {
      return res.docs;
    });

  return hashIds[0].id;
}

export async function getHashValueById({ idList, collectionPath }) {
  const hashtagRef = firestore.collection(`${collectionPath}Hashtag`);
  if (!idList) return null;
}

export async function getHashDocIdListByHashId({ collectionPath, hashId }) {
  const ref = firestore.collection(`${collectionPath}Hashtag`);
  return ref
    .doc(hashId)
    .get()
    .then((res) => res.data()!.docIdList);
}

export async function getHashDataByIdList({ collectionPath, hashtagIdList }) {
  const ref = firestore.collection(`${collectionPath}`);

  const getList = await Promise.all(
    hashtagIdList.map((id) =>
      ref
        .doc(id)
        .get()
        .then((res) => {
          const docData = res.data();
          return docData ? { id, ...docData } : {};
        }),
    ),
  );

  return getList;
}
